export const SET_LAUNCHER_TEXT = 'LOADINGBAR_TEXTS_SET_LAUNCHER_TEXT'
export const SET_VERSION_TEXT = 'LOADINGBAR_TEXTS_SET_VERSION_TEXT'
export const SET_PATCH_NOTES = 'LOADINGBAR_TEXTS_SET_PATCH_NOTES'
export const SET_TEXTS = 'LOADINGBAR_TEXTS_SET_TEXTS'



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/texts/constants.js